export const initSearchIcon = () => {
    const searchIcons = document.getElementsByName('search-icon');
    const searchTexts = document.getElementsByName('Search');
    const searchSubmit = document.getElementsByName('SearchSubmit');

    if (searchIcons.length > 0 && searchTexts.length > 0 && searchSubmit.length > 0) {
        searchIcons[0].addEventListener('click', () => {
            searchTexts[0].classList.toggle('--hidden');
            searchSubmit[0].classList.toggle('--hidden');
            searchIcons[0].classList.toggle('--hidden');
        });
    }
};
